
/* injects from baggage-loader */

import React from 'react';
import {Route, IndexRoute, Router} from "react-router";
import Layout from "../../../../dev/terminal/containers/layout";
import Live from "../../../../dev/terminal/containers/live";
import GameWrapperWrapper from '../../../../dev/terminal/containers/gameWrapperWrapper';
import Prematch from "../../../../dev/terminal/containers/prematch";
import Today from "../../../../dev/terminal/containers/today";
import Home2 from "../../../../dev/terminal/containers/home2";
import TopGames from "../../../../dev/terminal/containers/topGames";
import ErrorNotFoundPage from "../../../../dev/terminal/components/errorNotFoundPage";
import VirtualGames from "../../../../dev/terminal/containers/virtualGames";
import Casino from "../../../../dev/terminal/containers/casino";
import createHistory from 'history/createBrowserHistory';
import LiveCasino from "../../../../dev/terminal/containers/liveCasino";
import AdminWrapper from '../../../../dev/terminal/containers/adminWrapper'
import Result from '../../../../dev/terminal/containers/result';
import HorseRacing from "../../../../dev/terminal/containers/horseRacing";
import Greyhounds from '../../../../dev/terminal/containers/greyhounds';

const history = createHistory({
    basename: '/base'
});

export const routerBuilder = (store) => (
    <Router history={history}>
        <Route path="/" component={Layout}>
            <IndexRoute component={Home2}/>
            <Route path="live">
                <IndexRoute component={Live}/>
                <Route path="(:sportAlias)" component={Live}/>
                <Route path="(:sportAlias/:regionId)" component={Live}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Live}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="topGames">
                <IndexRoute component={TopGames}/>
                <Route path="(:sportAlias)" component={TopGames}/>
                <Route path="(:sportAlias/:regionId)" component={TopGames}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={TopGames}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="prematch">
                <IndexRoute component={Prematch}/>
                <Route path="(:sportAlias)" component={Prematch}/>
                <Route path="(:sportAlias/:regionId)" component={Prematch}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Prematch}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="horseRacing">
                <IndexRoute component={HorseRacing}/>
                <Route path="(:sportId)" component={HorseRacing}/>
                <Route path="(:sportId/:regionId)" component={HorseRacing}/>
                <Route path="(:sportId/:regionId/:competitionId)" component={HorseRacing} />
                <Route path="(:sportId/:regionId/:competitionId/:gameId)" component={HorseRacing}/>
            </Route>
            <Route path="greyhounds">
                <IndexRoute component={Greyhounds}/>
                <Route path="(:sportId)" component={Greyhounds}/>
                <Route path="(:sportId/:regionId)" component={Greyhounds}/>
                <Route path="(:sportId/:regionId/:competitionId)" component={Greyhounds} />
                <Route path="(:sportId/:regionId/:competitionId/:gameId)" component={Greyhounds} />
            </Route>
            <Route path="today">
                <IndexRoute component={Today}/>
                <Route path="(:sportAlias)" component={Today}/>
                <Route path="(:sportAlias/:regionId)" component={Today}/>
                <Route path="(:sportAlias/:regionId/:competitionId)" component={Today}>
                    <Route path="(:gameId)" component={GameWrapperWrapper}/>
                </Route>
            </Route>
            <Route path="casino">
                <IndexRoute component={Casino}/>
                <Route path="(:filter)" component={Casino}/>
            </Route>
            <Route path="dealer">
                <IndexRoute component={LiveCasino}/>
            </Route>
            <Route path="result">
                <IndexRoute component={Result}/>
            </Route>
            <Route path="virtualGames">
                <IndexRoute component={VirtualGames}/>
                <Route path="(:sportAlias)" component={VirtualGames}/>
            </Route>
            <Route path="admin">
                <IndexRoute component={AdminWrapper}/>
            </Route>
            <Route path="*" component={ErrorNotFoundPage}/>
        </Route>
    </Router>
);
